var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8528 17.3536C16.6574 17.549 16.3412 17.549 16.1456 17.3536L11.9996 13.2067L7.85277 17.3536C7.65736 17.549 7.3412 17.549 7.14558 17.3536C6.95017 17.1582 6.95017 16.8421 7.14558 16.6464L11.2934 12.5005L7.1462 8.35362C6.9508 8.15821 6.9508 7.84206 7.1462 7.64643C7.34161 7.45103 7.65777 7.45103 7.85339 7.64643L11.9996 11.7942L16.1465 7.64737C16.3419 7.45196 16.6581 7.45196 16.8537 7.64737C17.0491 7.84278 17.0491 8.15893 16.8537 8.35456L12.7059 12.5005L16.8528 16.6474C17.0496 16.8411 17.0496 17.1599 16.8528 17.3536Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.110b20986119a5bf1139b04f8de6da7d.svg";
export { ForwardRef as ReactComponent };